



































import { defineComponent } from "@vue/composition-api";
import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import { FollowersMap } from "../../types";
import FollowersItem from "../FollowersItem";

export default defineComponent({
  name: "FollowersView",
  components: { BasePage, PageTitle, InfiniteScroll, FollowersItem, EmptyContent },
  props: {
    userId: { type: String, required: true },
    user: { type: Object as () => UserPublicData },
    loading: { type: Boolean, required: true },
    scroll: { type: Boolean, required: true },
    authUserId: { type: String, required: true },
    isFollowingPage: { type: Boolean, required: true },
    isAuthor: { type: Boolean, default: false },
    showFollowing: { type: Boolean, default: true },
    showFollowers: { type: Boolean, default: true },
    isAdmin: { type: Boolean, default: false },
    followers: { type: Array as () => Follower[], required: true },
    authorFollowings: { type: Object as () => FollowersMap, required: true },
  },
  computed: {
    screenName(): string {
      return this.user?.screenName ?? "";
    },

    emptyText(): string {
      if (this.isAuthor) {
        if (this.isFollowingPage) {
          return $t("You aren't following anyone yet");
        } else {
          return $t("You don't have followers yet");
        }
      } else {
        if (this.isFollowingPage) {
          return $t("{0} isn't following anyone yet", [this.screenName]);
        } else {
          return $t("{0} doesn't have followers yet", [this.screenName]);
        }
      }
    },
  },
  methods: {
    onBackClick() {
      this.$router.push(this.user ? getProfileUrl(this.user) : getProfileUrl(this.userId));
    },
  },
});
